import { Controller } from '@hotwired/stimulus';
import { Dropdown, Tooltip } from 'bootstrap';

// Connects to data-controller="pdf-history"
export default class extends Controller {
  static targets = [ 'toggle', 'menu', 'item' ];

  connect() {
    this.syncVisibility();
  }

  itemTargetConnected() {
    this.syncVisibility();
  }

  itemTargetDisconnected() {
    this.syncVisibility();
  }

  toggleTargetDisconnected( toggle ) {
    Dropdown.getInstance( toggle )?.dispose();

    // Restore tooltip in case the toggle was swapped out while its menu was open
    this.restoreTooltip();
  }

  toggleTargetConnected( toggle ) {
    if( this.hasMenuTarget && this.menuTarget.classList.contains( 'show' ) ){
      this.menuTarget.classList.remove( 'show' );
      Dropdown.getOrCreateInstance( toggle ).show();
    }
  }

  hideTooltip() {
    // Disable so hover can't re-show it while the menu stays open
    const tooltip = Tooltip.getInstance( this.element.querySelector( '.pdf-history-toggle-wrapper' ) );
    tooltip?.disable();
    tooltip?.hide();
  }

  restoreTooltip() {
    Tooltip.getInstance( this.element.querySelector( '.pdf-history-toggle-wrapper' ) )?.enable();
  }

  syncVisibility() {
    if( !this.hasMenuTarget ) return;

    const empty = !this.hasItemTarget;

    this.menuTarget.classList.toggle( 'd-none', empty );

    if( empty && this.hasToggleTarget ){
      Dropdown.getInstance( this.toggleTarget )?.hide();
    }
  }

  resetNestedMenus() {
    // Close any open history menu when the main dropdown opens or closes
    this.element.nextElementSibling?.querySelectorAll( '.pdf-history-toggle.show' ).forEach( ( toggle ) => {
      Dropdown.getInstance( toggle )?.hide();
    } );
  }
}
